import { CALL_API } from '../middleware/api'

export const CUSTOMER_PROFILE_REQUEST = 'CUSTOMER_PROFILE_REQUEST'
export const CUSTOMER_PROFILE_SUCCESS = 'CUSTOMER_PROFILE_SUCCESS'
export const CUSTOMER_PROFILE_FAILURE = 'CUSTOMER_PROFILE_FAILURE'
export const CUSTOMER_PROFILE_RESET   = 'CUSTOMER_PROFILE_RESET'

export function fetchCustomerProfile() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'customers/me',
      authenticated: true,
      types: [
        CUSTOMER_PROFILE_REQUEST,
        CUSTOMER_PROFILE_SUCCESS,
        CUSTOMER_PROFILE_FAILURE,
      ],
    },
  }
}

export function resetCustomerProfile() {
  return { type: CUSTOMER_PROFILE_RESET }
}
